/**
 * Boot. Shared file — changes need lead sign-off.
 */

import { Game } from './core/game.js';

const canvas = document.getElementById('gl');
const boot = document.getElementById('boot');

const params = new URLSearchParams(location.search);

// The harness serves a fixed viewport so shots are reproducible.
const forcedW = params.get('w') ? Number(params.get('w')) : 0;
const forcedH = params.get('h') ? Number(params.get('h')) : 0;

const game = new Game(canvas, {
  harness: params.get('harness') === '1',
  size: forcedW && forcedH ? { width: forcedW, height: forcedH } : null,
  onError: (e) => {
    console.error('[boot]', e);
    if (boot) {
      boot.hidden = false;
      boot.textContent = 'Error: ' + (e && e.message ? e.message : String(e));
      boot.classList.add('boot--error');
    }
  },
});

window.addEventListener('resize', () => game.requestResize());
document.addEventListener('visibilitychange', () => {
  if (document.hidden) game.stop();
  else if (!game.isHarness) game.start();
});

game.init()
  .then(() => {
    if (boot) boot.hidden = true;
    console.log(
      `%cPOTHOLE PATROL: MONTRÉAL%c  seed=${game.seed}  harness=${game.isHarness}`,
      'background:#ff5a1e;color:#141414;font-weight:700;padding:2px 6px;border-radius:3px',
      'color:#888'
    );
  })
  .catch((e) => {
    console.error('[boot] fatal', e);
    if (boot) {
      boot.hidden = false;
      boot.textContent = 'Fatal: ' + (e && e.stack ? e.stack : String(e));
      boot.classList.add('boot--error');
    }
  });

// Expose for console poking and for the harness page.
window.__GAME__ = game;
